import classNames from 'classnames';
import { forwardRef } from 'react';
import BsModal from 'react-bootstrap/Modal';
import type { ModalProps } from 'react-bootstrap/Modal';

/** Unified dialog class — responsive rules live in `_modal.scss` / `customstyles.css`. */
export const APP_MODAL_DIALOG_CLASS = 'app-modal-dialog';
export const APP_MODAL_CONTENT_CLASS = 'app-modal-content';
export const APP_MODAL_CLASS = 'app-modal';

type AppModalProps = ModalProps;

/**
 * Parent Modal for the whole panel.
 * Always attaches responsive classes so every dialog stays inside the viewport on mobile.
 * Drop-in for `react-bootstrap` Modal (`Modal.Header` / `Body` / `Footer` / `Title` included).
 */
const AppModalBase = forwardRef<HTMLDivElement, AppModalProps>(
  function AppModal(
    { className, dialogClassName, contentClassName, ...props },
    ref
  ) {
    return (
      <BsModal
        ref={ref}
        className={classNames(APP_MODAL_CLASS, className)}
        dialogClassName={classNames(APP_MODAL_DIALOG_CLASS, dialogClassName)}
        contentClassName={classNames(APP_MODAL_CONTENT_CLASS, contentClassName)}
        {...props}
      />
    );
  }
);

type AppModalComponent = typeof AppModalBase & {
  Header: typeof BsModal.Header;
  Title: typeof BsModal.Title;
  Body: typeof BsModal.Body;
  Footer: typeof BsModal.Footer;
  Dialog: typeof BsModal.Dialog;
};

const AppModal = AppModalBase as AppModalComponent;

AppModal.Header = BsModal.Header;
AppModal.Title = BsModal.Title;
AppModal.Body = BsModal.Body;
AppModal.Footer = BsModal.Footer;
AppModal.Dialog = BsModal.Dialog;

export default AppModal;
export { AppModal as Modal };
export type { AppModalProps, ModalProps };
